import { Navigate, useParams } from 'react-router-dom';

export function AWARepairPage() {
  const { workspaceId } = useParams();

  // Issues are always linked via the 1:1 Issue → Repair model — redirect to issues page
  return <Navigate to={`/${workspaceId}/issues`} replace state={{ fromLegacyRepair: true }} />;
}
